import React from 'react'
import { Field } from 'redux-form'
import { renderTextField } from '../../../Forms/fieldRenderers'

function CampoDuracionVolcado () {
  return (
    <div style={{ textAlign: 'center', width: '90%', margin: 'auto' }}>
      <Field
        name='duracionVolcado'
        type='number'
        label='Duración de volcado (en minutos)'
        component={renderTextField}
        autoFocus={false}
        style={{ textAlign: 'center' }}
        placeholder=''
        maxLength={2}
      />
    </div>
  )
}

export default CampoDuracionVolcado
